module.exports = __webpack_public_path__ + "img/shot_img121302.6b2bc233.gif";